export function RequestReceivedPage() {
  return `
    <main id="contenido" class="confirmation-page">
      <section class="confirmation-section" aria-labelledby="confirmation-title">
        <div class="site-container confirmation-shell">
          <div class="confirmation-card">
            <span class="confirmation-icon" aria-hidden="true">✓</span>
            <span class="eyebrow">Demostración</span>
            <h1 id="confirmation-title">Solicitud recibida</h1>
            <p>Gracias por tu interés en GR SoftMedia. Hemos recibido tu solicitud de demostración y nos pondremos en contacto contigo próximamente.</p>
            <a class="button button-primary" href="/" data-route>Volver al inicio</a>
          </div>
        </div>
      </section>
    </main>
  `;
}
